import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BannerDto } from '../shared/dto/banner.dto';
import { BannerAdService } from '../shared/banner-ad.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-banner-ad-edit-dialog',
  templateUrl: './banner-ad-edit-dialog.component.html',
  styleUrls: ['./banner-ad-edit-dialog.component.less'],
    standalone: false
})
export class BannerAdEditDialogComponent implements OnInit {
  @Output() bannerSaved = new EventEmitter<BannerDto>();
  banner: BannerDto;
  show = false;
  loadingBanner = false;
  isSaving = false;
  creatingUnlinkedBanner = false;

  get showCrud() {
    return this.banner?.BannerId || this.banner?.ProfileId || this.loadingBanner || this.creatingUnlinkedBanner;
  }

  constructor(private _bannerAdService: BannerAdService, private _notificationService: NotificationService) {}

  ngOnInit(): void {}

  public open(bannerId?: number) {
    this.show = true;
    if (bannerId) {
      this.loadingBanner = true;
      this._bannerAdService
        .get(bannerId)
        .then((banner) => {
          this.banner = banner;
        })
        .catch((err) => {
          this._notificationService.httpError(err);
        })
        .finally(() => {
          this.loadingBanner = false;
        });
    }
  }

  createUnlinkedBanner() {
    this.creatingUnlinkedBanner = true;
    this.banner = {} as BannerDto;
  }

  initWithProfile(profileId: number) {
    this.banner = {
      ProfileId: profileId,
    } as BannerDto;
  }

  close() {
    this.banner = null;
    this.creatingUnlinkedBanner = false;
    this.show = false;
  }

  save() {
    this.isSaving = true;
    let crudPromise;
    if (this.banner.BannerId) {
      crudPromise = this._bannerAdService.update(this.banner);
    } else {
      crudPromise = this._bannerAdService.create(this.banner);
    }
    crudPromise
      .then(() => {
        this.bannerSaved.emit(this.banner);
        this._notificationService.translateSuccess('banner-ads.edit.saved-successfully');
        this.close();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => (this.isSaving = false));
  }
}
